<template>
	<div class="c-tips"><slot></slot></div>
</template>

<script>
	export default {
		name: 'cTips'
	}
</script>

<style lang="stylus" scoped>
	.c-tips {
		z-index: 11;
		position: sticky;
		top: 0;
		padding: .14rem .3rem;
		line-height: .36rem;
		font-size: .26rem;
		color: #FF5555;
		background: #FFF5F5;
	}
</style>